// Calendar dates pinned to midnight UTC, not the browser's local offset.
export const toApiDate = (value: string): string =>
  `${value.split("T")[0]}T00:00:00Z`;

export const toApiDateOrNull = (value: string | null): string | null =>
  value ? toApiDate(value) : null;
